import React from "react";


const useInstagramFeed = (id) => {
    const [feed, setFeed] = React.useState({});

    const cargar = () => fetch(`${process.env.REACT_APP_API_URL}/?id=${id}`)
        .then(res => res.json())
        .then(datos => { setFeed(datos) });

    React.useEffect(() => { cargar() }, [id])

    return { feed };
};
export default useInstagramFeed
